import React from 'react';
import { Avatar, Box, IconButton, Typography } from "@mui/material";
import _ from 'lodash';
import { BackArrowIcon } from 'src/Icons';

export const SelectedStudioHeader = ({
  studio,
  onBack,
}: any) => {
  const categoriesCount: any = studio.categories.length;
  const subCategoriesCount: any = _.sumBy(studio.categories, (cat: any) => cat.children.length);
  const servicesCount: any = studio.services.length;

  const Delimiter = () => (
    <Box sx={{
      width: '1px',
      height: '8px',
      backgroundColor: '#EC90AA',
      margin: '0px 12px',
    }} />
  );

  return (<Box
    display="flex"
    flexDirection="row"
    alignItems="center"
    justifyContent="space-between"
    sx={{
      height: '64px',
    }}
  >
    <IconButton
      onClick={onBack}
      sx={{
        width: "48px",
        height: "48px",
        borderRadius: "12px",
        backgroundColor: "#F3F3F3",
        color: "#676767",
        fontSize: "24px",
        marginRight: '16px',
      }}
      disableRipple
    >
      <BackArrowIcon fontSize="inherit" />
    </IconButton>
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
    }}>
      <Avatar
        variant="rounded"
        src={studio?.images?.[0]}
        sx={{
          width: "64px",
          height: "64px",
          borderRadius: "6px",
          marginRight: '8px',
        }}
      />
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '64px',
        justifyContent: 'space-between',
      }}>
        <Box>
          <Typography sx={{
            fontWeight: '600',
            color: '#363636',
            fontSize: '20px',
            textTransform: 'uppercase',
            lineHeight: 1,
          }}>
            {studio?.title}
          </Typography>
          <Typography sx={{
            fontWeight: '400',
            color: '#4F4F4F',
            fontSize: '14px',
          }}>
            {studio?.address}
          </Typography>
        </Box>
        <Box sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}>
          <Typography sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-end',
            fontWeight: '400',
            color: '#4F4F4F',
            fontSize: '14px',
          }}>
            <Typography sx={{
              fontWeight: '600',
              marginRight: '4px',
              fontSize: '14px',
            }}>
              {categoriesCount}
            </Typography>
            {`categor${categoriesCount === 1 ? 'y' : 'ies'}`}
          </Typography>
          <Delimiter />
          <Typography sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-end',
            fontWeight: '400',
            color: '#4F4F4F',
            fontSize: '14px',
          }}>
            <Typography sx={{
              fontWeight: '600',
              marginRight: '4px',
              fontSize: '14px',
            }}>
              {subCategoriesCount}
            </Typography>
            {`subcategor${subCategoriesCount === 1 ? 'y' : 'ies'}`}
          </Typography>
          <Delimiter />
          <Typography sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-end',
            fontWeight: '400',
            color: '#4F4F4F',
            fontSize: '14px',
          }}>
            <Typography sx={{
              fontWeight: '600',
              marginRight: '4px',
              fontSize: '14px',
            }}>
              {servicesCount}
            </Typography>
            {`service${servicesCount === 1 ? '' : 's'}`}
          </Typography>
        </Box>
      </Box>
    </Box>
  </Box>)
};